import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    BASE,
    APIS,
    URLS,
    SF_PRE_VRFN_DOC_SRCH,
    SG_PRE_VRFN_DOC_LIST,
} from "@/tra/tancis/ptli/comnmdle/doc/services/PtliDocMgmtService";

/*
 * Pre-Verification Document Management List
 * !== 사전검증 문서관리 목록 ==!
 */
export const PTLI0412001Q = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0024" },
        ],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const form = {
        preVrfnDocSrch: useForm({
            defaultSchema: SF_PRE_VRFN_DOC_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        preVrfnDocList: useGrid({
            defaultSchema: SG_PRE_VRFN_DOC_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getPreVrfnDocList: useFetch({
            api: (page = grid.preVrfnDocList.page) =>
                APIS.getPreVrfnDocList(form.preVrfnDocSrch.getValues(), page, grid.preVrfnDocList.size),
            enabled: comnUtils.isEmpty(form.preVrfnDocSrch.errors),
            key: [grid.preVrfnDocList.page, grid.preVrfnDocList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.preVrfnDocSrch.getValues(),
                    page: grid.preVrfnDocList.page,
                    size: grid.preVrfnDocList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            dclaDocCd: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0412003s}/${rowValues.dclaDocCd}?menuId=${menuId}`}>{value}</Link>;
            },
        },
    };

    const handler = {
        getPreVrfnDocList: () => {
            grid.preVrfnDocList.setPage(0);
            fetch.getPreVrfnDocList.fetch(0);
        },
    };

    useEffect(() => {
        handler.getPreVrfnDocList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.preVrfnDocSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.preVrfnDocSrch.schema.dclaDocCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.preVrfnDocSrch.schema.docNm} />
                            <Group.Control {...form.preVrfnDocSrch.schema.dclaCoTpCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.preVrfnDocSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={() => handler.getPreVrfnDocList()} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.preVrfnDocList.grid}
                            data={fetch.getPreVrfnDocList.data?.preVrfnDocList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Button
                    role="new"
                    onClick={() => {
                        navigate(`${URLS.ptli0412002s}?menuId=${menuId}`);
                    }}
                ></Layout.Button>
            </Layout>
        </Page>
    );
};
